(function () {
	const getUniqueId = () => {
		const array = (Date.now() + Math.random().toString(36).substring(2, 9)).split('');

		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}

		return array.join('');
	};

	/**
	 * Validate CSS selector to prevent DOM XSS
	 * @param {string} selector - The selector to validate
	 * @returns {boolean} - True if selector appears safe
	 */
	const isValidSelector = (selector) => {
		// Check for dangerous patterns
		const dangerousPatterns = [
			/script/i,
			/javascript:/i,
			/on\w+\s*=/i, // Event handlers like onclick=
			/<[^>]*>/i, // HTML tags
			/eval/i,
			/expression/i,
		];

		return !dangerousPatterns.some((pattern) => pattern.test(selector));
	};

	const getSelectedNodes = (selectors) => {
		// Validate selectors before using them
		const safeSelectors = selectors.filter((selector) => {
			if (typeof selector !== 'string') return false;
			return isValidSelector(selector);
		});

		if (safeSelectors.length === 0) {
			return [];
		}

		try {
			const allNodes = document.querySelectorAll(safeSelectors.join(', '));
			return Array.from(allNodes).filter((node) => {
				// Exclude the TOC title itself
				if (node.classList.contains('tocifier-article-nav__title')) return false;

				// Exclude headings inside footer elements
				const footer = node.closest('footer, .footer, #footer, [role="contentinfo"]');
				if (footer) return false;

				return true;
			});
		} catch (e) {
			// If querySelectorAll fails (invalid selector), return empty array
			console.warn('Tocifier: Invalid selector detected', e);
			return [];
		}
	};

	const getWindowScrollProgress = () => {
		const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		return 100 - (window.scrollY / height) * 100;
	};

	/**
	 * Sanitize ID to prevent XSS
	 * @param {string} id - The ID to sanitize
	 * @returns {string} - Sanitized ID
	 */
	const sanitizeId = (id) => {
		// Remove any characters that aren't alphanumeric, hyphen, underscore, or colon
		return id.replace(/[^a-zA-Z0-9\-_:]/g, '');
	};

	/**
	 * Convert a heading's text into a readable, anchor-safe slug.
	 * Strips diacritics (å/ä → a, ö → o, é → e, etc.), collapses non-alnum
	 * runs into single hyphens, preserves the heading's casing, and trims
	 * edge hyphens. Returns '' when the source has no usable characters.
	 * @param {string} text
	 * @returns {string}
	 */
	const slugify = (text) => {
		if (typeof text !== 'string') return '';
		return text
			.normalize('NFKD')
			.replace(/[̀-ͯ]/g, '')
			.replace(/[^A-Za-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')
			.slice(0, 80)
			.replace(/-+$/g, '');
	};

	const generateNav = (nodes, highlighted) => {
		let navItems = [];
		const usedIds = new Set();
		// Seed with existing in-document ids so we never collide with them.
		document.querySelectorAll('[id]').forEach((el) => usedIds.add(el.id));

		for (const node of nodes) {
			if (node.classList.contains('tocifier-article-nav__title')) continue;

			const li = document.createElement('li');
			const a = document.createElement('a');

			let id;
			if (node.id) {
				id = sanitizeId(node.id);
			} else {
				const base = slugify(node.textContent || '') || 'section';
				id = base;
				let suffix = 2;
				while (usedIds.has(id)) {
					id = base + '-' + suffix++;
				}
				id = sanitizeId(id) || 'id-' + getUniqueId();
			}
			usedIds.add(id);

			// Use textContent to prevent XSS
			a.textContent = node.textContent || '';
			a.href = '#' + id;

			if (highlighted.some((className) => node.classList.contains(className))) {
				li.classList.add('tocifier-highlight');
			}

			// Sync the heading's id back when it's missing OR when sanitization
			// changed it (e.g. an editor-saved anchor like "foo?" — the TOC href
			// drops the "?" but the heading must match for fragment navigation).
			if (node.id !== id) {
				node.id = id;
			}

			li.appendChild(a);
			navItems.push(li);
		}

		return navItems;
	};

	const selectors =
		tocifierSettings.selectors && tocifierSettings.selectors !== '' ?
			[tocifierSettings.selectors]
		:	['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
	const highlighted =
		tocifierSettings.highlighted && tocifierSettings.highlighted !== '' ?
			tocifierSettings.highlighted.split(',').map((item) => item.replace('.', ''))
		:	['toc-highlight'];
	const nodes = getSelectedNodes(selectors);

	if (!nodes.length) return;

	const navItems = generateNav(nodes, highlighted);

	const stickyNav = document.getElementById('tocifier-contents-sticky');
	const stickyList = document.getElementById('tocifier-contents-sticky-list');
	const details = document.querySelector('.tocifier-contents-sticky-details');

	// The floating sticky widget is optional — it is omitted when the block is
	// rendered with allowSticky=false (e.g. when an inline TOC is shown). Only
	// wire it up when present; the inline "On this page" list below populates
	// regardless, so it never depends on the sticky widget existing.
	if (stickyNav && stickyList) {
		// When details window is open,is adding overflow: hidden in to body.
		if (details) {
			details.addEventListener('toggle', () => {
				if (details.hasAttribute('open')) {
					document.body.classList.add('tocifier-details-open');
				} else {
					document.body.classList.remove('tocifier-details-open');
				}
			});
		}

		// Populate sticky list
		for (const item of navItems) {
			const clone = item.cloneNode(true);
			clone.addEventListener('click', (e) => {
				e.target.closest('details').open = false;
			});
			stickyList.appendChild(clone);
		}
	}

	// Populate inline ("On this page") lists if present.
	// Each matching `.tocifier-contents-static-list` lives inside a
	// `.tocifier-article-nav` wrapper that starts with the `loading` class.
	const staticLists = document.querySelectorAll('.tocifier-contents-static-list');
	if (staticLists.length > 0) {
		staticLists.forEach((list) => {
			const wrapper = list.closest('nav');
			const heightContainer = list.parentNode;
			const rawMaxHeight =
				heightContainer && heightContainer.style && heightContainer.style.maxHeight ?
					parseInt(heightContainer.style.maxHeight.replace('px', ''), 10)
				:	NaN;

			if (navItems.length < 2 && wrapper) {
				wrapper.remove();
				return;
			}

			for (const item of navItems) {
				if (!item.innerText) continue;
				list.appendChild(item.cloneNode(true));
			}

			if (wrapper) {
				if (!isNaN(rawMaxHeight) && list.scrollHeight > rawMaxHeight) {
					wrapper.classList.add('has-overflow-items');
				}
				wrapper.classList.remove('loading');
			}
		});

		// "Show all" / "Show less" button toggles the inline list between
		// its collapsed (initial max-height) and expanded (100%) state.
		document.querySelectorAll('.tocifier-contents-static-view-all').forEach((btn) => {
			const wrapper = btn.closest('nav');
			const innerList = wrapper && wrapper.querySelector('.tocifier-contents-static-list');
			const heightContainer = innerList ? innerList.parentNode : null;
			if (!heightContainer) return;

			const collapsedStyle = heightContainer.getAttribute('style') || '';
			const labelExpand = btn.dataset.labelExpand || btn.textContent.trim();
			const labelCollapse = btn.dataset.labelCollapse || '';
			const labelSpan = btn.querySelector('span') || btn;

			// If no collapse label was provided, fall back to one-way reveal
			// to preserve historical behavior.
			if (!labelCollapse) {
				btn.addEventListener('click', (event) => {
					event.preventDefault();
					heightContainer.setAttribute('style', 'max-height: 100%;');
					btn.style.display = 'none';
				});
				return;
			}

			btn.addEventListener('click', (event) => {
				event.preventDefault();
				const expanded = btn.getAttribute('aria-expanded') === 'true';
				if (expanded) {
					heightContainer.setAttribute('style', collapsedStyle);
					btn.setAttribute('aria-expanded', 'false');
					labelSpan.textContent = labelExpand;
				} else {
					heightContainer.setAttribute('style', 'max-height: 100%;');
					btn.setAttribute('aria-expanded', 'true');
					labelSpan.textContent = labelCollapse;
				}
			});
		});
	}

	// Sticky-widget scroll behaviour only applies when the widget is rendered.
	if (stickyNav && stickyList) {
		// Show sticky nav when user scrolls past the first heading
		window.addEventListener('scroll', () => {
			if (nodes.length === 0) return;

			const firstNode = nodes[0];
			const { top, height } = firstNode.getBoundingClientRect();

			if (top + height < 0) {
				stickyNav.classList.remove('tocifier-contents-sticky--fade-out');
				stickyNav.classList.add('tocifier-contents-sticky--fade-in');
				stickyNav.hidden = false;
				return;
			}
			stickyNav.classList.remove('tocifier-contents-sticky--fade-in');
			stickyNav.classList.add('tocifier-contents-sticky--fade-out');
		});

		window.addEventListener('scroll', () => {
			const scrolled = getWindowScrollProgress();
			stickyNav.style.setProperty('--page-scroll-progress', scrolled + '%');

			let i = 0;
			for (const node of nodes) {
				const { top } = node.getBoundingClientRect();
				const listItem = stickyList.children[i];
				if (top <= 0 && listItem) {
					listItem.classList.add('is-item-active');
				} else if (listItem) {
					listItem.classList.remove('is-item-active');
				}
				i++;
			}
		});
	}
})();
